import { createFileRoute } from "@tanstack/react-router";
import { BlogPostsDocument } from "@/graphql/definitions";
import { BlogListPage } from "@/components/blog/BlogListPage";
import { blogPostsPerPage, blogTitle, blogDescription } from "@/config/blog";
import { localizePostMetasFn } from "@/server/blog";
import { localeUrl } from "@/lib/seo";
import {
  blogListingHead,
  localizedBlogDescription,
  localizedBlogName,
} from "@/lib/blog-seo";

export const Route = createFileRoute("/$locale/blog/")({
  loader: async ({ params, context }) => {
    const [sectionName, sectionDescription, { data, error }] = await Promise.all([
      localizedBlogName(params.locale),
      localizedBlogDescription(params.locale),
      context.client.query({
        query: BlogPostsDocument,
        variables: { page: 1, pageSize: blogPostsPerPage },
        fetchPolicy: "network-only",
      }),
    ]);
    if (!data) throw error ?? new Error("BlogPosts query returned no data");
    const posts = await localizePostMetasFn({ data: { locale: params.locale, posts: [...data.blogPosts.posts] } });
    return { ...data.blogPosts, posts, sectionName, sectionDescription };
  },
  head: ({ loaderData, params }) => {
    // Localized section name / description; the English constant only survives
    // when the loader has not resolved yet.
    const sectionName = loaderData?.sectionName ?? blogTitle;
    const sectionDescription =
      loaderData?.sectionDescription ?? blogDescription;
    return blogListingHead({
      sectionName,
      description: sectionDescription,
      canonicalUrl: localeUrl(params.locale, "/blog"),
      sectionUrl: localeUrl(params.locale, "/blog"),
      locale: params.locale,
      posts: loaderData?.posts ?? [],
    });
  },
  component: function BlogListRoute() {
    const blogPosts = Route.useLoaderData();
    return <BlogListPage page={blogPosts} />;
  },
});
